export default "__VITE_ASSET__B8l0IKCu__"